import React, { useEffect, useRef } from "react"
import PageWrapper from "../../components/page/PageWrapper"
import useReduxDispatch from "../../store/useReduxDispatch"
import "./StatusPage.scss"
import { ensureHealthStatusesThunk } from "../../store/thunks/healthStatusThunks"
import { useSelector } from "react-redux"
import { healthStatusSelectors } from "../../store/reducers/healthStatusReducer "
import { formatLocalDateTime } from "../../util/dateUtil"

interface IStatusPageProps {}

const StatusPage = ({}: IStatusPageProps) => {
    const dispatch = useReduxDispatch()
    const intervalRef = useRef<NodeJS.Timer | undefined>()

    const healthStatuses = useSelector(healthStatusSelectors.healthStatuses)
    const generalhealthStatus = healthStatuses?.find((hs) => !hs.paymentType && hs.enabled)

    useEffect(() => {
        const stopRefresher = () => {
            if (intervalRef.current) {
                clearInterval(intervalRef.current)
            }
        }

        const startRefresher = () => {
            stopRefresher()
            dispatch(ensureHealthStatusesThunk(true))
            intervalRef.current = setInterval(() => {
                dispatch(ensureHealthStatusesThunk(true))
            }, 1000 * 60)
        }
        startRefresher()

        const visibilityListener = () => {
            if (document.hidden) {
                stopRefresher()
            } else {
                startRefresher()
            }
        }

        const onFocus = () => {
            startRefresher()
        }

        const onBlur = () => {
            stopRefresher()
        }

        document.addEventListener("visibilitychange", visibilityListener)

        addEventListener("focus", onFocus)
        addEventListener("blur", onBlur)

        // Show footer
        document.getElementById("status-page")?.click()

        return () => {
            stopRefresher()
            document.removeEventListener("visibilitychange", visibilityListener)
            removeEventListener("focus", onFocus)
            removeEventListener("blur", onBlur)
        }
    }, [])

    return (
        <PageWrapper fullWidth noPadding>
            <div id="status-page">
                <div className="status-page__outer-container">
                    <div className="status-page__title">Status of Swiipe payments</div>
                    <div className="status-page__container">
                        {!generalhealthStatus && <div className="status-page__text">There are no reported problems.</div>}
                        {generalhealthStatus && (
                            <>
                                <div className="status-page__time">
                                    {formatLocalDateTime(generalhealthStatus.created, "medium", "medium")}
                                </div>
                                <div className="status-page__text status-page__text-title">{generalhealthStatus.title}</div>
                                <div className="status-page__text">{generalhealthStatus.description}</div>
                            </>
                        )}
                    </div>
                </div>
            </div>
        </PageWrapper>
    )
}

export default StatusPage
